import React, { useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { Scrollbar } from "react-scrollbars-custom";
import { DatePicker } from 'react-persian-datepicker';
import moment from "moment-jalaali";
import EntrnaceHeader from './EntranceHeader';

const Personalinfo = (props) => {

    const [loading, setLoading] = useState(false)
    const [state, setState] = useState({
        dateValue: '',
        fName: '',
        lName: '',
        nationalCode: '',
        dateActive: false,
        errorValid: false
    })

    useEffect(() => {

        const infoPerson = JSON.parse(localStorage.getItem('personalInfo'))
        setTimeout(() => {
            if (infoPerson !== null) {
                setState({
                    ...state,
                    fName: infoPerson.firstName,
                    lName: infoPerson.lastName,
                    nationalCode: infoPerson.nationalCode,
                    // dateValue: moment(infoPerson.dateBirthday)
                })
                setTimeout(() => {
                    setState({
                        ...state,
                        dateValue: moment(infoPerson.dateBirthday)
                    })
                }, 300)
            }

            setLoading(true)

        }, 300);

    }, [])

    const handleSelect = (date) => {
        setState({
            ...state,
            dateValue: date
        })
    }

    const handleInputValue = (e, target) => {
        setState({
            ...state,
            [target]: e.target.value
        })
    }

    const calendarStyles = {
        calendarContainer: 'calendarContainer',
        dayPickerContainer: 'dayPickerContainer',
        monthsList: 'monthsList',
        daysOfWeek: 'daysOfWeek',
        dayWrapper: 'dayWrapper',
        selected: 'selected',
        heading: 'heading',
        placeholder: "تاریخ"
    }

    const contniue = () => {
        const data = {
            firstName: state.fName,
            lastName: state.lName,
            nationalCode: state.nationalCode,
            dateBirthday: state.dateValue // .format('jYYYY/jM/jD')
        }
        if (data.firstName.trim().length !== 0 &&
            data.lastName.trim().length !== 0 &&
            data.nationalCode.trim().length == 10 &&
            data.dateBirthday.length !== 0) {

            localStorage.setItem('personalInfo', JSON.stringify(data));
            setLoading(false)
            setTimeout(() => {
                props.history.push('/entrance/step4')
            }, 400);

        } else {
            setState({
                ...state,
                errorValid: true
            })
        }
    }

    return (
        <Fragment>
			<EntrnaceHeader />
        <div className={`entrnc-web pesronal-info ${loading ? 'active' : ''}`}>
            <div className="bx-info">
                <Scrollbar>
                    <div className="titles-style-1">
                        <h4>اطلاعات شخصی</h4>
                    </div>
                    <div className="step-progress">
                        <span className="active"></span>
                        <span></span>
                        <span></span>
                    </div>
                    <div className="info-inputs">

                        <div className="input-form">
                            <TextField
                                id="standard-basic"
                                label="نام *"
                                value={state.fName}
                                onChange={(e) => handleInputValue(e, 'fName')} />
                            <span className={`error-respns ${(state.errorValid && state.fName.trim().length == 0) ? 'active' : ''}`}>
                                <i className="icon-exclamation-mark"></i>
                        نام خود را کامل وارد کنید
                        </span>
                        </div>
                        <div className="input-form">
                            <TextField
                                id="standard-basic"
                                label="نام خانوادگی *"
                                value={state.lName}
                                onChange={(e) => handleInputValue(e, 'lName')} />
                            <span className={`error-respns ${(state.errorValid && state.lName.trim().length == 0) ? 'active' : ''}`}>
                                <i className="icon-exclamation-mark"></i>
                                نام خانوادگی خود را کامل وارد کنید
                            </span>
                        </div>
                        <div className="input-form national-cd">
                            <TextField
                                id="standard-basic"
                                label="کد ملی *"
                                value={state.nationalCode}
                                onChange={(e) => handleInputValue(e, 'nationalCode')}
                                onInput={(e) => {
                                    if (!(/^\d+$/).test(e.target.value)) {
                                        e.target.value = ''
                                    }
                                    e.target.value = e.target.value.slice(0, 10)
                                }} />
                            <span className={`error-respns ${(state.errorValid && state.nationalCode.trim().length !== 10) ? 'active' : ''}`}>
                                <i className="icon-exclamation-mark"></i>
                        کد ملی خود را کامل وارد کنید
                    </span>
                        </div>
                        <div className="input-form date" >
                            <span>تاریخ تولد *</span>
                            <i className="icon-calendar-11"></i>
                            <DatePicker
                                inputFormat="jYYYY/jM/jD"
                                onChange={(dateBirth) => handleSelect(dateBirth)}
                                calendarStyles={calendarStyles}
                                value={state.dateValue}
                                max={moment()} />
                            <span className={`error-respns ${(state.errorValid && state.dateValue.length == 0) ? 'active' : ''}`}>
                                <i className="icon-exclamation-mark"></i>
                                نام خانوادگی خود را کامل وارد کنید
                            </span>
                        </div>

                    </div>
                    <div className="btn-base btn-black btn-sircle">
                        <Button
                            variant="contained"
                            onClick={contniue}>ادامه</Button>
                    </div>
                </Scrollbar>
            </div>
        </div >
        </Fragment>
    );
}

export default Personalinfo;